export default __webpack_public_path__ + "static/media/logo.d2db4419.png";